/* eslint-disable import/no-cycle */
import { Files } from '@flatsy/types/Files'
import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { deleteFile, getFilesList, UpdateApplicantFiles } from './Action'
import { FilesState } from './Type'

export const filesAdapter = createEntityAdapter<Files>()

// export const initialState: ApplicantsState = {
export const initialState = filesAdapter.getInitialState<FilesState>({
  fetchStatus: FetchStatus.IDLE,
})

export const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /* -------------------------------------------------------------------------- */
    /*                               GET FILES LIST                               */
    /* -------------------------------------------------------------------------- */
    builder.addCase(getFilesList.pending, (state) => {
      state.fetchStatus = FetchStatus.LOADING
    })
    builder.addCase(getFilesList.fulfilled, (state, action) => {
      filesAdapter.setAll(state, action.payload)
      state.fetchStatus = FetchStatus.SUCCEEDED
    })
    builder.addCase(getFilesList.rejected, (state) => {
      state.fetchStatus = FetchStatus.FAILED
    })
    /* -------------------------------------------------------------------------- */
    /*                            UPDATE APPLICANT FILE                           */
    /* -------------------------------------------------------------------------- */
    builder.addCase(UpdateApplicantFiles.fulfilled, (state, action) => {
      filesAdapter.addOne(state, action.payload)
    })
    /* -------------------------------------------------------------------------- */
    /*                                 DELETE FILE                                */
    /* -------------------------------------------------------------------------- */
    builder.addCase(deleteFile.fulfilled, (state, action) => {
      filesAdapter.removeOne(state, action.meta.arg.file)
    })
  },
})
